/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { PandaboardApiInstance } from "../../../helpers/api";
import { VehicleReviewSummary } from "../interfaces/vehicle-review-summary.interfaces";

type ReviewSearchSubject = {
  brand: { _id: string };
  model: { _id: string };
  cylindersCapacity: number;
  year: number;
};

export const getVehicleReviews = (vehicle: ReviewSearchSubject, limit?: number): Promise<VehicleReviewSummary | null> =>
  PandaboardApiInstance
    .get(`vehicle-reviews?brand=${vehicle.brand._id}&model=${vehicle.model._id}&cc=${vehicle.cylindersCapacity}&year=${vehicle.year}${limit ? `&limit=${limit}` : ""}`)
    .then((response) => new VehicleReviewSummary(response.data))
    .catch(() => null);
